<div *ngIf="!classes || !edition">
    <app-spinner></app-spinner>
</div>

<div *ngIf="edition && classes">
    
    <app-component-selector 
        [campusId]="edition.campusId" 
        [editionId]="edition.editionId"
        [webResourceId]="webResourceId">
    </app-component-selector>
    
    <div class="container mt-3">

        <mat-tab-group animationDuration="0ms">

            <mat-tab [label]="classification.name" *ngFor="let classification of getDistinctClassifications()">
                <div class="my-4">
                    <app-courses-summary-table 
                        [classes]="getClassesByClassification(classification)"
                        [openEnrollments]="edition.areEnrollmentsOpen"
                        [showFreePlaces]="showFreePlaces"
                        [showOccupation]="showOccupation">
                    </app-courses-summary-table>
                </div>
            </mat-tab>
            
            <mat-tab label="Descuentos" *ngIf="edition.discounts && edition.discounts.length > 0"> 
                <div class="my-4">
                    <p *ngIf="maxDiscount">
                        El {{ campusName }} pone a disposición de todos los interesados una amplia oferta de descuentos 
                        sobre el precio del curso, con un <strong>máximo acumulable del {{ maxDiscount }}%</strong>.
                    </p>
                    <app-discounts-summary-table 
                        [discounts]="edition.discounts">
                    </app-discounts-summary-table>
                </div>
            </mat-tab>
        
        </mat-tab-group>

    </div>
    

</div>
